<div mat-dialog-content>Please select image files only!</div>
<div mat-dialog-actions class="rightFloat">
  <button mat-button mat-dialog-close>Ok</button>
</div>
